import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.role !== "admin") {
        setError("This account does not have admin access.");
        setLoading(false);
        return;
      }
      toast.success("Welcome, Admin");
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="ChainSmart" className="h-16 mx-auto rounded-sm mb-5" />
          <div className="inline-flex items-center gap-2 text-gold text-sm">
            <ShieldCheck className="w-4 h-4" /> Admin Portal
          </div>
        </div>

        <div className="bg-white p-8">
          <h1 className="font-serif text-3xl text-obsidian mb-6">Admin Login</h1>
          {error && <div className="bg-discount/10 border border-discount/30 text-discount text-sm px-4 py-3 mb-5 rounded-sm" data-testid="admin-login-error">{error}</div>}
          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="ae">Email</Label>
              <Input id="ae" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 rounded-sm" data-testid="admin-email" />
            </div>
            <div>
              <Label htmlFor="ap">Password</Label>
              <Input id="ap" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 rounded-sm" data-testid="admin-password" />
            </div>
            <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-obsidian text-white font-semibold py-3.5 hover:bg-gold hover:text-obsidian transition-colors disabled:opacity-50 rounded-sm" data-testid="admin-login-submit">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
